import { useState } from 'react';
import rotateImg from '../assets/icons/rotate.svg';
import soundImg from '../assets/icons/sound.svg';



export default function Card(props) {
	//console.log(props)
	const [rotate, setRotate] = useState(false);
	const [isPlay, setPlay] = useState(false);

	function handleRotateBtnClick() {
		setRotate(true);
		setTimeout(() => {
			setRotate(false)
		}, 1800);
	}

	function handleSoundBtnClick(sound) {
		let audio='';
		if(sound) {
		audio = new Audio(sound);
		
		if (!isPlay) {
			audio.play();
			setPlay(true);
		}
		audio.addEventListener('ended', () => {setPlay(false)}) }
	}

	let bgStyle={
		backgroundColor: '' 
	};
	if (props.view === 'cat') {
		bgStyle.backgroundColor = 'rgb(30 58 138)' 
	} else {
		bgStyle.backgroundColor = 'rgb(52 211 153)' 
	}
	

	return (
		<a className={"card__wrapper max-w-xs w-full "  + (rotate ? "rotate" : "")}
		view={props.view}
		id={props.id}
		onClick={props.myClick}
		>
			<div 
			style={bgStyle}
			className={"card card__front max-w-xs w-full flex flex-col justify-between border " + (props.view === 'cat' ? "border-blue-900 text-white cursor-pointer card-cat" : "border-emerald-400")}
			>
				<img
				className="card__img w-full"
				src={props.view === 'cat' ? props.item.worlds[0].src : props.item.src}
				alt={props.view === 'cat' ? props.item.category : props.item.title} 
				/>
				<footer className='flex justify-center items-center grow'>
					{props.view === 'worlds' ?
					<button 
					className='card-btn rotate-btn w-14'
					style={!props.sound ? {visibility:'hidden', pointerEvents:'none'} : {}}
					>
						<img src={soundImg} 
						className="w-full" 
						alt="sound" 
						onClick={()=>handleSoundBtnClick(props.sound)}
						/>
					</button> : false}
					<div 
					className="title px-4 py-2 text-2xl pointer-events-none"
					>
						{props.view === 'cat' ? props.item.trans : props.item.title}
					</div>
					{props.view === 'worlds' ?
					<button 
					className='card-btn rotate-btn w-14'
					>
						<img src={rotateImg} 
						className="w-full" 
						alt="rotate" 
						onClick={()=>handleRotateBtnClick()}
						/>
					</button> : false}
				</footer>
			</div>

			<div 
			className="card card__back max-w-xs w-full flex flex-col justify-between bg-emerald-400"
			>
				<img
				className="card__img w-full"
				src={props.item.src}
				alt={props.item.title} 
				/>
				<footer className='flex justify-center items-center grow'>
					<div 
					className="title px-8 py-2 text-2xl"
					>
						{props.item.trans}
					</div>
				</footer>
			</div>
		</a>

	);
}